import * as React from 'react';

const ContactLensSpecs = ({ specs , labels , isTabletLandscapeUp  })=>/*#__PURE__*/ React.createElement("div", {
        className: "line-item__spec-box"
    }, specs.map((spec)=>/*#__PURE__*/ React.createElement("span", {
            className: "line-item__spec",
            key: spec.name
        }, /*#__PURE__*/ React.createElement("span", {
            className: "line-item__spec-label"
        }, isTabletLandscapeUp ? labels[spec.name] : labels[`${spec.name}Abbr`]), /*#__PURE__*/ React.createElement("span", {
            className: "line-item__spec-value"
        }, spec.value, " "))
    ))
;

export { ContactLensSpecs };
//# sourceMappingURL=ContactLensSpecs.js.map
